import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FileUploader} from 'ng2-file-upload';
import {ApiService} from '../services/api.service';
import {HttpEventType, HttpResponse} from '@angular/common/http';
import {LocalStorageService} from 'angular-2-local-storage';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../environments/environment';
import {LoginService} from '../services/login.service';
import {Location} from '@angular/common';
import {ReCaptchaComponent} from 'angular2-recaptcha';
import {NotificationsService} from 'angular2-notifications';
import {ModalHelper} from '../services/modalService/modal.helper';
import {User} from '../services/model/user';
import {Subscription} from 'rxjs/Subscription';
import {EventService} from '../services/event.service';
import {GoogleAnalyticsService} from '../services/google-analytics-service';
import { TranslateService } from '@ngx-translate/core';
import { BackendTranslateService } from '../helper/backend-translate.service';
import { HelperService } from '../helper/helper.service';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})

export class HomeComponent implements OnInit, OnDestroy {
  @ViewChild(ReCaptchaComponent) captcha: ReCaptchaComponent;

  hasBaseDropZoneOver = false;
  environment = environment;
  uploader: FileUploader = new FileUploader({
    url: `${environment.AmazonS3}`
  });
  public progress: number = -1;
  public operation = '';
  ws;
  ruid = '';
  currentUser: User = null;
  recaptcha = false;
  appLanguage = window.localStorage.getItem('lang');
  uploadedFile: any;
  s3MaxUploadSize: string;
  public fileName = '';
  public fileSize = 0;

  private subscription: Subscription;

  constructor(private apiService: ApiService,
              private router: Router,
              private route: ActivatedRoute,
              private ga: GoogleAnalyticsService,
              private localStorageService: LocalStorageService,
              public loginService: LoginService,
              private modalHelper: ModalHelper,
              private location: Location,
              private notifications: NotificationsService,
              private eventService: EventService,
              private translate: TranslateService,
              private backendTranslate: BackendTranslateService,
              private helperService: HelperService) {
      this.subscription = this.eventService.getMessage().subscribe((event) => {
          if (event.type === 'user') {
			this.currentUser = event.data;
			this.s3MaxUploadSize = this.apiService.getS3SuitableMaxUploadSize(this.currentUser);
          }
      });
  }

  ngOnInit() {
    this.recaptcha = false;
    this.currentUser = this.loginService.getCurrentUser();
    this.accountInfo();
    this.s3MaxUploadSize = this.apiService.getS3SuitableMaxUploadSize(this.currentUser);
      // .subscribe((user) => {
      //     this.isLoggedIn = user.isLoggedIn;
      //     this.accountInfo();
      // }, (error) => {
      //   this.accountInfo();
      // });
  }
  
  fileOverBase(fileOver: any) {
    this.hasBaseDropZoneOver = fileOver;
  }

  checkFile(file) {
      this.loginService.checkLoggedIn()
          .subscribe((currentUser) => {
              if (this.currentUser.isLoggedIn) {
                  this.uploadFile(file, '');
              } else {
                  this.recaptcha = true;
                  this.captcha.reset();
                  this.uploadedFile = file;
              }
          });
  }

  uploadFile(file, captcha) {
  	if(this.currentUser.isLoggedIn) {
  		this.ga.emitEvent('Home Page', 'Upload File', 'Upload');
  	} else {
  		this.ga.emitEvent('Home Page Not Registered', 'Upload File', 'Upload');
  	} 
    
    const that = this;
    this.recaptcha = false;

    let s3MaxUploadSize = this.apiService.getS3SuitableMaxUploadSize(this.currentUser);
		let awsError = this.translate.instant('common.awsErrorFileSizeLimit') + s3MaxUploadSize;
    if(this.currentUser.isLoggedIn && this.currentUser.paid && (file[0].size > environment.advancedPlanUploadLimit)) {
      this.modalHelper.openGeneric(
        {
        title: this.translate.instant('common.awsErrorFileSizeLimitTitle'),
        message: awsError,
        order : 0,
              addFooterBtn : true,
              isCancel: true,
              cancelText: this.translate.instant('common.close'),
                centered: true
        },
        null
      );
      return;
    } else if(this.currentUser.isLoggedIn && !this.currentUser.paid && (file[0].size > environment.basicPlanUploadLimit)) {
      this.modalHelper.openFilesLimitUploadModal(
        {
          title: this.translate.instant('common.awsErrorFileSizeLimitTitle'),
          message: awsError
        },
        null
      );
      return;
    } else if(!this.currentUser.isLoggedIn && !this.currentUser.paid && (file[0].size > environment.demoPlanUploadLimit)) {
      this.modalHelper.openFilesLimitUploadModal(
        {
          title: this.translate.instant('common.awsErrorFileSizeLimitTitle'),
          message: awsError
        },
        null
      );
      return;
    }

    this.apiService.generateUid(file[0].name, captcha)
      .subscribe(uidData => {
        let ruid = this.apiService.uniqueName(uidData.ruid, file[0].name);
        this.ruid = ruid;
        this.fileName = file[0].name;
        this.fileSize = Math.ceil(file[0].size / 1024);
        this.localStorageService.set('lastFileName', file[0].name);
        that.progress = 0;
        that.operation = this.translate.instant('common.connecting');

        //TODO:[Rostislav] create alternative file submit for Google Storage
        this.apiService
          .upload(uidData, ruid, file[0])
          .subscribe(event => {
            if (event.type === HttpEventType.UploadProgress) {
              const percentDone = Math.round(100 * event.loaded / event.total);
              that.operation = this.translate.instant('common.uploading');
              that.progress = percentDone;
            } else if (event instanceof HttpResponse) {
              that.progress = 0;
              that.operation = this.translate.instant('common.pending');

              that.apiService.parseData(file[0].name)
                .subscribe(data => {
                  that.ws = new WebSocket(environment.webSocket);

                  that.ws.onmessage = function (wsEvent) {
                    const d = JSON.parse(wsEvent.data);
                    if (d.type == 'CONTEXT_ID') {
                    } else if (d.type == 'UID') {
                      that.ruid = d.value;
                    } else if (d.type == 'CLOSE') {
                      that.ws.close();
                      that.ws = null;
                      if (d.value == 'true') {
                        that.operation = that.translate.instant('reports.completed');
                        that.progress = 0;
                        that.getReportDetails(ruid, file[0].name);
                      } else {
                        that.operation = that.translate.instant('reports.completedErrors');
                      }
                    } else if (d.type === 'PROGRESS') {
                      that.progress = parseInt(d.value, 10);
                      that.operation = that.translate.instant('apiMessages.fileParserProgressMsg1') + ' ' + that.progress + '%';
                    } else if (d.type === 'INFO') {
                      that.progress = 0;
                      that.operation = that.backendTranslate.translateMessage(d.value);
                    } else if (d.type === 'WARN' || d.type === 'ERROR') {
                      ruid = undefined;
                      that.progress = 0;
                      that.modalHelper.openGeneric({message: that.backendTranslate.translateMessage(d.value)}, null);
                    }
                  };

                  that.ws.onopen = function (wsEvent) {
                    this.send(JSON.stringify({contextId: data.contextId}));
                    that.apiService.parseDataPost(ruid, data.fileName, data.contextId)
                      .subscribe((parseData) => {
                      });
                  };

                  that.ws.onclose = function (wsEvent) {
                  };
                });
            }
          }, (errorResponse) => {
            that.progress = -1;
            const awsError = that.apiService.getAWSMessage(errorResponse, that.currentUser);
            if (awsError) {
              if(that.currentUser.paid) {
              	this.modalHelper.openGeneric(
                  {
                  title: this.translate.instant('common.awsErrorFileSizeLimitTitle'),
                  message: awsError,
                  order : 0,
                        addFooterBtn : true,
                        isCancel: true,
                        cancelText: this.translate.instant('common.close'),
                          centered: true
                  },
                  null
              );
              } else {
              	this.modalHelper.openFilesLimitUploadModal(
						  {
                  title: this.translate.instant('common.awsErrorFileSizeLimitTitle'),
                  message: awsError
                  },
                  null
              );
              }
            } else {
              const errorMessage = that.apiService.getMessageFromError( errorResponse,
                  that.translate.instant('reports.error', {error: errorResponse.statusText}));
              that.notifications.error(this.translate.instant('common.error'), errorMessage);
            }
          });
      }, (error) => {
		  let isMaxNumberOfFileUploadsError = false;
	      if (error && error._body) {
	          try {
	              let jsonError = JSON.parse(error._body).message;
	              if(jsonError.startsWith("fileParserUidError3")){
	              		isMaxNumberOfFileUploadsError = true;
	              		this.modalHelper.openFilesLimitUploadModal({
	              				  title: this.translate.instant('reports.maxNumberOfFileUploads.title'),
	                              message: this.translate.instant('reports.maxNumberOfFileUploads.message'),
	                              showGoPremiumButton: true
	                    }, null);
	              }
	          } catch (exc) {
	          	  isMaxNumberOfFileUploadsError = false;
	          	  console.log(exc);
	          }
	      }

          if(!isMaxNumberOfFileUploadsError) {
          	  const errorMessage = that.apiService.getMessageFromError(error, this.translate.instant('reports.uploadFile'));
          	  this.notifications.error(this.translate.instant('common.error'), errorMessage);
          }
      });
  }

  getReportDetails(ruid, fileName) {
    if (ruid) {
      this.localStorageService.set('isParsed', true);
      this.helperService.doNotLoadHistoryReports();
      this.router.navigate(['reports/myreports'], {queryParams: {ruid: ruid, fileName: fileName, doNotLoadHistory: true}});
    }
  }

  accountInfo() {
  	if (!this.currentUser.isLoggedIn) {
  		this.route.params.subscribe(params => {
        if (params.resetid) {
          const resetid = params.resetid;
          this.location.go('/home');
          this.modalHelper.openReset({resetid: resetid}, null);
        } else if (params.registration) {
          if (params.registration === 'complete') {
            this.location.go('/home');
            this.modalHelper.openGeneric(
              {
                title: this.translate.instant('account.registrationSuccessful'),
                message: this.translate.instant('account.registrationRedirect'),
                order : 0,
            	addFooterBtn : true,
            	isCancel: true,
            	cancelText: this.translate.instant('common.continue'),
                centered: true
              },
              model => { this.modalHelper.openLogin({}); }
            );
          } else if (params.registration === 'failed') {
            this.location.go('/home');
            this.modalHelper.openGeneric(
              {
                title: this.translate.instant('common.error'),
                message: this.translate.instant('account.registrationFailed'),
                order : 0,
            	addFooterBtn : true,
            	isCancel: true,
            	cancelText: this.translate.instant('common.close'),
                centered: true
              },
              null
            );
          }
        } else if (params.emailvalidation) {
          	this.loginService.signOut(null).add(this.processEmailValidation(params));
        }
      });
  	}
  }
  
  processEmailValidation(params) {
	if (params.emailvalidation === 'successfully') {
        this.location.go('/home');
        this.modalHelper.openVerifyYourEmailValidationModalComponent(
          {
            title: this.translate.instant('account.verifyYourEmailValidation.successfully.title'),
            message: this.translate.instant('account.verifyYourEmailValidation.successfully.message'),
            isEmailValidated: true
          },
          model => { this.modalHelper.openLogin({}); }
        );
      } else if (params.emailvalidation === 'expired') {
        this.location.go('/home');
        this.modalHelper.openVerifyYourEmailValidationModalComponent(
          {
            title: this.translate.instant('account.verifyYourEmailValidation.expired.title'),
            message: this.translate.instant('account.verifyYourEmailValidation.expired.message'),
            isEmailValidated: false
          },
          null
        );
      }
  }
  
  loginPrompt() {
    this.modalHelper.openLogin({});
  }

  handleCorrectCaptcha(event) {
    this.uploadFile(this.uploadedFile, event);
  }

  createAccount() {
  	this.ga.emitEvent('Home Page Not Registered', 'Create free account', 'Upload');
    this.modalHelper.openCreate({}, null);
  }

  fileUpload(event) {
    if (event.target.files && event.target.files[0]) {
      this.checkFile(event.target.files);
    }
  }

  resetFileUpload(event) {
    event.target.value = null;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  
  sendGaEvent(ea) {
		this.ga.emitEvent('Home Page', ea, 'Click');
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/home/home.component.ts